<template>
  <div class="overflow-scroll-y" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="loadingText">
    <div class="card-header">
      <h2>志望動機を入力</h2>
      <p v-if="$globalVar.isYagiPrime" style="white-space: pre-line">
        {{ reasonLabelYagiprime }}
      </p>
      <!--<p v-else-if="formatId == 'rirekisho_job_change'" style="white-space: pre-line">
        {{ reasonLabel20250126 }}
      </p>-->
      <p v-else-if="formatId != 'rirekisho_job_change_old' ||
        formatId != 'rirekisho_job_change2' ||
        formatId != 'rirekisho_single' ||
        formatId != 'rirekisho_nophoto_double' ||
        formatId != 'rirekisho_nophoto'" style="white-space: pre-line">
        {{ reasonLabel20240717 }}
      </p>
      <p v-else style="white-space: pre-line">{{ reasonLabel }}</p>
    </div>

    <div class="add-item button-block">
      <button v-on:click="showModalFromNewAi" class="primary-button" v-if="$globalVar.in_app_payments">
        <span>AIで文章作成</span>
      </button>
      <el-button v-if="formatId != 'rirekisho_esf_challenged'" @click="$modal.show('reason-dialog')"
        type="success">例文から追加</el-button>
      <!-- <el-button v-if="formatId != 'rirekisho_esf_challenged'" @click="showModalFromNewAi()"
        id="prime-reasonai-btn" type="danger">最新のAIを使う</el-button> -->
      <el-button @click="$modal.show('proofread-tips-modal')" icon="el-icon-info" circle
        class="proofread-tips-btn"></el-button>
      <el-button @click="reasonClear()" icon="el-icon-delete" circle></el-button>
    </div>

    <div class="card-content">

      <!--例文-->
      <modal name="reason-dialog" :adaptive="true" :scrollable="true" height="auto">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('reason-dialog');" icon="el-icon-close" type="text"></el-button>
        </div>
        <div class="title">例文を選ぶ</div>
        <div class="description">
          <p>選択した例文が追加されます。</p>
          <p class="attention">例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。</p>
        </div>
        <ul class="example-sentence">
          <!-- AI生成の例文 -->
          <li v-if="aiGeneratedExampleReason" class="ai-generated-example"
            v-on:click="updateReason(aiGeneratedExampleReason.replace(/<br>/ig, '\n')); $modal.hide('reason-dialog')"
            key="ai-generated">
            <div class="title">
              <span class="ai-badge">AI生成</span>
              あなた向けの提案
            </div>
            <div class="body" v-html="aiGeneratedExampleReason"></div>
          </li>
          <!-- 通常の例文 -->
          <li v-for="(item, idx) in exampleSentences.reason"
            v-on:click="updateReason(item.description.replace(/<br>/ig, '\n')); $modal.hide('reason-dialog')"
            :key="idx">
            <div class="title">{{ item.title }}</div>
            <div class="body" v-html="item.description"></div>
          </li>
        </ul>
        <div class="text-right">
          <el-button @click="$modal.hide('reason-dialog')">閉じる</el-button>
        </div>
      </modal>

      <!--志望動機生成-->
      <modal name="ai-mypr-dialog" :adaptive="true" :scrollable="true" width="100%" height="auto" class="ai-mypr-modal">
        <div class="v--modal-close-top">
          <el-button @click="closeAiMyprDialog" icon="el-icon-circle-close" style="font-size: 2rem; padding: 0;"
            type="text"></el-button>
        </div>
        <div class="mypr-title-block">
          <p class="mypr-title-catch">1日1回無料</p>
          <h3>AIがあなたの内定を勝ち取る文章を作成</h3>
          <p class="mypr-lead">4つの質問に答えるだけで、AIがあなたの『得意なこと』と『企業への熱意』を結びつけます。</p>
        </div>

        <div v-if="!aiResultView">
          <!--入力項目-->
          <ul class="example-sentence-list">
            <li class="example-sentence-item">
              <p class="question-title">⓪ 応募先企業のURL（任意）</p>
              <div v-if="$globalVar.isYagiPrime">
                <el-input type="text" placeholder="https://example.co.jp/" title="応募先企業のURL" autocomplete="off"
                  v-model="formatData.ai_company_url" class="company-url-input"
                  @keyup.enter.native="extractCompanyInfo">
                  <el-button slot="append" @click="extractCompanyInfo" :loading="isExtractingCompanyInfo"
                    icon="el-icon-search">取得</el-button>
                </el-input>
                <div v-if="isCompanyInfoExtracted" style="margin-top: 8px;">
                  <p class="question-title">取得した企業情報（編集可能）</p>
                  <div class="el-textarea mb10">
                    <label>企業名</label>
                    <el-input type="text" v-model="formatData.ai_company_name" placeholder="企業名"></el-input>
                  </div>
                  <div class="el-textarea mb10">
                    <label>業種</label>
                    <el-input type="text" v-model="formatData.hopeIndustrycategory" placeholder="業種"></el-input>
                  </div>
                  <div class="el-textarea mb10">
                    <label>職種</label>
                    <el-input type="text" v-model="formatData.hopeJobcategory" placeholder="職種"></el-input>
                  </div>
                  <div class="el-textarea">
                    <label>企業の特徴・価値観</label>
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 8 }"
                      v-model="formatData.ai_company_values" placeholder="企業の特徴・価値観"></el-input>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-input disabled placeholder="🔒 プライム会員のみ"></el-input>
              </div>
            </li>
            <li class="example-sentence-item">
              <p class="question-title">① 得意なこと <span>必須</span></p>
              <div class="el-textarea">
                <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 7 }" placeholder="・英語
・プログラミング
・コミュニケーション
・Word
など" title="得意なこと" autocomplete="off" v-model="formatData.ai_strength">
                </el-input>
              </div>
            </li>
            <li class="example-sentence-item">
              <p class="question-title">② 希望企業名</p>
              <div class="el-textarea">
                <el-input type="text" autosize placeholder="株式会社Yagish" title="希望企業名" autocomplete="off"
                  v-model="formatData.ai_company_name">
                </el-input>
              </div>
            </li>
            <li class="example-sentence-item">
              <p class="question-title">③ 希望業界</p>
              <div class="el-textarea">
                <label class="selectbox-3">
                  <select v-model="formatData.hopeIndustrycategory" placeholder="選択してください">
                    <option v-for="item in hopeIndustryOptions" :key="item" :value="item">{{ item }}</option>
                  </select>
                </label>
              </div>
              <div v-if="isGeneratingCareerSuggestions || industrySuggestions.length" class="flex recommend-chip">
                <p class="chip-title">候補✨</p>
                <ul class="flex chip-list">
                  <li v-if="isGeneratingCareerSuggestions" class="chip-item chip-item--loading">AIが候補を生成中...</li>
                  <li v-else v-for="item in industrySuggestions" :key="item" class="chip-item"
                    @click="selectIndustrySuggestion(item)">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <p class="question-title sub-question-title">現在のあなたのいる業界</p>
              <div class="el-textarea">
                <label class="selectbox-3">
                  <select v-model="formatData.currentIndustrycategory" placeholder="選択してください">
                    <option v-for="item in hopeIndustryOptions" :key="item" :value="item">{{ item }}</option>
                  </select>
                </label>
              </div>
              <div v-if="isGeneratingCareerSuggestions || currentIndustrySuggestions.length"
                class="flex recommend-chip">
                <p class="chip-title">候補✨</p>
                <ul class="flex chip-list">
                  <li v-if="isGeneratingCareerSuggestions" class="chip-item chip-item--loading">AIが候補を生成中...</li>
                  <li v-else v-for="item in currentIndustrySuggestions" :key="item" class="chip-item"
                    @click="selectCurrentIndustrySuggestion(item)">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </li>
            <li class="example-sentence-item">
              <p class="question-title">④ 希望職種</p>
              <div class="el-textarea">
                <label class="selectbox-3">
                  <select v-model="formatData.hopeJobcategory" placeholder="選択してください">
                    <option v-for="item in hopeCareerJobcategoryOptions" :key="item" :value="item">{{ item }}</option>
                  </select>
                </label>
              </div>
              <div v-if="isGeneratingCareerSuggestions || jobcategorySuggestions.length" class="flex recommend-chip">
                <p class="chip-title">候補✨</p>
                <ul class="flex chip-list">
                  <li v-if="isGeneratingCareerSuggestions" class="chip-item chip-item--loading">AIが候補を生成中...</li>
                  <li v-else v-for="item in jobcategorySuggestions" :key="item" class="chip-item"
                    @click="selectJobcategorySuggestion(item)">
                    {{ item }}
                  </li>
                </ul>
              </div>
              <p class="question-title sub-question-title">現在のあなたのいる職種</p>
              <div class="el-textarea">
                <label class="selectbox-3">
                  <select v-model="formatData.currentJobcategory" placeholder="選択してください">
                    <option v-for="item in hopeCareerJobcategoryOptions" :key="item" :value="item">{{ item }}</option>
                  </select>
                </label>
              </div>
              <div v-if="isGeneratingCareerSuggestions || currentJobcategorySuggestions.length"
                class="flex recommend-chip">
                <p class="chip-title">候補✨</p>
                <ul class="flex chip-list">
                  <li v-if="isGeneratingCareerSuggestions" class="chip-item chip-item--loading">AIが候補を生成中...</li>
                  <li v-else v-for="item in currentJobcategorySuggestions" :key="item" class="chip-item"
                    @click="selectCurrentJobcategorySuggestion(item)">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </li>
            <li class="example-sentence-item prime-cv-block">
              <el-button v-if="!$firebase.isAuthenticated" @click="$eventHub.$emit('open-login-dialog')">
                <span>ログインして生成する</span>
              </el-button>
              <el-button v-else @click="handleAIMypr" class="ai-mypr-cta-btn">
                <span>{{ (!$globalVar.isYagiPrime && aiUsageCount >= 1) ? '🔒️ AIで文章作成をする' : 'AIで文章作成をする' }}</span>
              </el-button>
              <p class="ai-mypr-cta-note">1日1回無料</p>
            </li>

            <li class="example-sentence-item example-sentence-item--self">
              <p class="question-title ai-mypr-self-title">以下の履歴書内容も文章作成の際に参考にしています。<br>最終学歴、最終職歴、取得資格、入力されている志望動機</p>
              <p class="question-title">{{ formatData.lastestEdu ? '最終学歴' : '最終学歴を教えてください' }}</p>
              <div class="el-textarea">
                <el-input type="textarea" autosize title="最終学歴" autocomplete="off"
                  v-model="formatData.lastestEdu"></el-input>
              </div>

              <p class="question-title">{{ formatData.lastestJob ? '最終職歴' : '最終職歴を教えてください' }}</p>
              <div class="el-textarea">
                <el-input type="textarea" autosize title="最終職歴" autocomplete="off"
                  v-model="formatData.lastestJob"></el-input>
              </div>

              <p class="question-title">{{ getLicences ? '取得資格' : '取得資格を教えてください' }}</p>
              <div class="el-textarea">
                <p>{{ getLicences }}</p>
              </div>

              <p class="question-title">{{ formatData.reason ? '志望動機' : '志望動機を教えてください' }}</p>
              <div class="el-textarea">
                <p class="reason-txt">{{ formatData.reason }}</p>
              </div>

            </li>
          </ul>

          <div class="mypr-popup-btnarea" v-if="$globalVar.in_app_payments">
            <p class="count-txt" v-if="$globalVar.isYagiPrime">
              <span>利用回数：</span><span>{{ aiUsageCount }} / {{ aiMaxUsageCount }}回</span>
            </p>

            <p class="mypr-attention">※例文選択・AI再生成をすると、現在入力中の文章は<br>上書きされますのでご注意ください。</p>
            <el-button v-if="!$firebase.isAuthenticated" v-show="!aiIsStreaming"
              @click="$eventHub.$emit('open-login-dialog')">
              <span>ログインして生成する</span>
            </el-button>
            <el-button v-else v-show="!aiIsStreaming" @click="handleAIMypr" class="ai-mypr-cta-btn">
              <span>{{ (!$globalVar.isYagiPrime && aiUsageCount >= 1) ? '🔒️ AIで文章作成をする' : 'AIで文章作成をする' }}</span>
            </el-button>
            <p class="ai-mypr-cta-note" v-show="!aiIsStreaming">1日1回無料</p>
          </div>
        </div>

        <div v-else>
          <div v-if="aiIsThinking" class="ai-thinking" @click="aiReasoningText ? toggleAiReasoning() : null">
            <span class="ai-thinking__icon"></span>
            <span class="ai-thinking__label">{{ aiThinkingLabel }}</span>
            <span class="ai-thinking__dots">
              <span class="ai-thinking__dot"></span>
              <span class="ai-thinking__dot"></span>
              <span class="ai-thinking__dot"></span>
            </span>
          </div>
          <div v-if="aiReasoningText">
            <div class="ai-reasoning__toggle" @click="toggleAiReasoning">
              <span class="ai-reasoning__arrow" :class="{ 'ai-reasoning__arrow--open': aiShowReasoning }">▶</span>
              {{ aiShowReasoning ? '思考過程を隠す' : '思考過程を見る' }}
            </div>
            <div class="ai-reasoning" :class="aiShowReasoning ? 'ai-reasoning--expanded' : 'ai-reasoning--collapsed'">
              <div class="ai-reasoning__content">{{ aiReasoningText }}</div>
            </div>
          </div>
          <ul v-show="!aiIsThinking" class="example-sentence">
            <li
              v-on:click="!aiIsStreaming && (updateReason(aiResultMyprResult.replace(/<br>/ig, '\n')), closeAiMyprDialog(), aiResultView = false)">
              <div class="title">AIからの提案</div>
              <div class="body"><span v-html="aiResultMyprResult"></span><span v-if="aiIsStreaming && !aiIsThinking"
                  class="ai-cursor"></span></div>
            </li>
          </ul>
          <div v-if="!$globalVar.isYagiPrime" v-show="!aiIsThinking" class="text-right" style="margin-top: 10px;">
            ＼全文を作成する場合は／<br>
            <el-button @click="goYagiprimeRegister()" id="prime-reasonai-register-btn" v-if="$globalVar.in_app_payments"
              style="color: #fff; background-color: #e3165c; border-color: #e3165c;">ヤギプライム会員になる</el-button>
          </div>
        </div>

        <div class="text-right" v-show="!aiIsStreaming">
          <el-button v-if="$globalVar.isYagiPrime && aiResultView" type="primary"
            @click="toggleAIMyprDialog">もう一度作る</el-button>
          <el-button @click="closeAiMyprDialog">閉じる</el-button>
        </div>

      </modal>

      <!--校正ヒント-->
      <modal name="proofread-tips-modal" :adaptive="true" :scrollable="true" height="auto">
        <div class="v--modal-close-top">
          <el-button @click="$modal.hide('proofread-tips-modal')" icon="el-icon-close" type="text"></el-button>
        </div>
        <div class="proofread-tips-content">
          <div class="proofread-tips-main-title">履歴書添削ツール ガイド</div>

          <div class="proofread-section-heading">基本的な使い方</div>
          <div class="proofread-steps">
            <div class="proofread-step">
              <div class="proofread-step-icon proofread-step-icon--neutral">
                <i class="el-icon-document"></i>
              </div>
              <p class="proofread-step-name">1. 文章を入力</p>
              <p class="proofread-step-desc">文章入力後<br class="sp-only">自動でチェック</p>
            </div>
            <span class="proofread-step-arrow">›</span>
            <div class="proofread-step">
              <div class="proofread-step-icon proofread-step-icon--alert">
                <span class="proofread-wavy-mark">≋</span>
              </div>
              <p class="proofread-step-name">2. 問題箇所を確認</p>
              <p class="proofread-step-desc">波線を選択、<br class="sp-only">理由を確認</p>
            </div>
            <span class="proofread-step-arrow">›</span>
            <div class="proofread-step">
              <div class="proofread-step-icon proofread-step-icon--neutral">
                <i class="el-icon-edit-outline"></i>
              </div>
              <p class="proofread-step-name">3. 1クリック修正</p>
              <p class="proofread-step-desc">修正候補を選択、<br class="sp-only">置き換え</p>
            </div>
          </div>

          <div class="proofread-section-heading">気をつけたいポイント</div>
          <div class="proofread-points-grid">
            <div class="proofread-point proofread-point--beige">
              <div class="proofread-point-icon proofread-point-icon--beige">
                <i class="el-icon-user"></i>
              </div>
              <div class="proofread-point-body">
                <div class="proofread-point-title">「貴社」を使う</div>
                <div class="proofread-point-sub">履歴書は貴社</div>
              </div>
            </div>
            <div class="proofread-point proofread-point--salmon">
              <div class="proofread-point-icon proofread-point-icon--salmon">
                <i class="el-icon-edit"></i>
              </div>
              <div class="proofread-point-body">
                <div class="proofread-point-title">文体の統一</div>
                <div class="proofread-point-sub">です•ます<br>/だ•である</div>
              </div>
            </div>
            <div class="proofread-point proofread-point--green">
              <div class="proofread-point-icon proofread-point-icon--green">
                <span>〜</span>
              </div>
              <div class="proofread-point-body">
                <div class="proofread-point-title">ら抜き言葉</div>
                <div class="proofread-point-sub">見れる<br>→見られる</div>
              </div>
            </div>
            <div class="proofread-point">
              <div class="proofread-point-icon proofread-point-icon--neutral">
                <i class="el-icon-chat-dot-round"></i>
              </div>
              <div class="proofread-point-body">
                <div class="proofread-point-title">話し言葉を避ける</div>
                <div class="proofread-point-sub">めっちゃ<br>→非常に</div>
              </div>
            </div>
            <div class="proofread-point">
              <div class="proofread-point-icon proofread-point-icon--neutral">
                <i class="el-icon-phone-outline"></i>
              </div>
              <div class="proofread-point-body">
                <div class="proofread-point-title">二重敬語</div>
                <div class="proofread-point-sub">おっしゃられる<br>→おっしゃる</div>
              </div>
            </div>
            <div class="proofread-point">
              <div class="proofread-point-icon proofread-point-icon--neutral">
                <i class="el-icon-date"></i>
              </div>
              <div class="proofread-point-body">
                <div class="proofread-point-title">西暦・和暦統一</div>
                <div class="proofread-point-sub">2024年/令和6年</div>
              </div>
            </div>
          </div>

          <div class="proofread-section-heading proofread-section-heading--mt">ヤギプライム会員向け：AIによる推敲補助</div>
          <p class="proofread-prime-desc">ヤギプライム会員の方は、ルールベースの赤い波線に加えて、AI（Gemini）を使った以下の推敲補助がご利用いただけます。</p>
          <ul class="proofread-prime-list">
            <li><strong>青い波線（言い換え提案）</strong>：より洗練された言い回しへの置き換え候補を、文脈に合わせて AI が提案します。</li>
            <li><strong>続きの提案（Ghost text）</strong>：入力が止まったタイミングで、文章の続きをグレーで表示します。Tab キーで採用できます。</li>
            <li><strong>短縮案（AIで短縮）</strong>：入力欄からはみ出した場合、現在の文章を短くまとめた複数案を AI が生成し、タブで比較できます。</li>
          </ul>

          <div class="proofread-section-heading proofread-section-heading--mt">よくある質問</div>
          <div class="proofread-faq">
            <details class="proofread-faq-item">
              <summary>赤い波線は何ですか？</summary>
              <div class="proofread-faq-answer">誤字脱字や敬語の誤り、文体の不統一など、履歴書で気をつけたい表現を自動で検出しています。Word や Google
                ドキュメントのスペルチェックと同じ仕組みです。</div>
            </details>
            <details class="proofread-faq-item">
              <summary>指摘を無視したいときは？</summary>
              <div class="proofread-faq-answer">波線をクリックして表示されるポップアップの「このままにする」を押すと、その指摘の波線が消えます。ページを再読み込みするとリセットされます。
              </div>
            </details>
            <details class="proofread-faq-item">
              <summary>入力した文章は外部に送信されますか？</summary>
              <div class="proofread-faq-answer">
                赤い波線の校正チェックはすべてお使いのブラウザ内で処理されており、文章が外部のサーバーに送信されることはありません。<br>
                一方、ヤギプライム会員向けの <strong>青い波線・続きの提案・短縮案</strong> は AI による処理のため、対象の文章を当社および Google Cloud（Gemini
                API）のサーバーに送信します。送信内容は提案生成の目的にのみ利用され、AIモデルの学習には使用されません（利用規約 第2条⑭ および 第32条をご確認ください）。
              </div>
            </details>
            <details class="proofread-faq-item">
              <summary>どんなミスを検出できますか？</summary>
              <div class="proofread-faq-answer">
                赤い波線では、「御社→貴社」の敬称、ら抜き言葉、西暦・和暦の混在、二重敬語、話し言葉、文体（です/ます・だ/である）の混在、冗長な表現、全角・半角の不統一を検出します。青い波線（ヤギプライム会員限定）ではさらに、文脈に応じた「より洗練された言い換え」を提案します。
              </div>
            </details>
          </div>
        </div>
      </modal>

      <el-input type="textarea" v-model="reason" v-proofread="{ phase2: true, context: '志望動機' }"
        :autosize="autosizeSettings"></el-input>
      <div class="button-container" v-if="$globalVar.in_app_payments">
        <button v-on:click="insertSentence" v-if="$firebase.isAuthenticated && isSendMail" class="primary-button">
          <span>メールの添削文章を挿入</span>
        </button>
      </div>
      <div class=" attention-limit character" v-if="previewErrors.reason">
        <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
        <div class="summarize-link-row" v-if="!summarizePreview.visible">
          <a v-if="$globalVar.isYagiPrime" class="summarize-link" href="javascript:void(0)" @click="openSummarizeModal">
            AIで短縮案を見る
          </a>
          <a v-else class="summarize-link summarize-link-gate" href="javascript:void(0)"
            @click="showYagiprimeForSummarize">
            AIで短縮案を見る（ヤギプライム会員限定）
          </a>
        </div>

        <div v-if="summarizePreview.visible" class="summarize-preview-inline">
          <div v-if="summarizePreview.loading" class="summarize-preview-status">
            <i class="el-icon-loading"></i>
            <span>AI が短縮案を作成しています…</span>
          </div>
          <div v-else-if="summarizePreview.rateLimited" class="summarize-preview-rate-limit">
            <p class="summarize-preview-rate-limit-title">
              <i class="el-icon-info"></i> 本日のお試し回数の上限に達しました
            </p>
            <p class="summarize-preview-gate-note">
              🔒 <strong>ヤギプライム</strong>なら、文字数オーバー時の短縮案を<strong>いつでも何度でも</strong>利用できます。<br>
              3 パターン（骨格キープ／言い換え／ミニマル）から選んで反映も可能です。
            </p>
            <div class="summarize-preview-actions">
              <el-button size="small" @click="closeSummarizePreview">閉じる</el-button>
              <el-button size="small" type="primary" @click="openYagiprimeFromPreview">
                ✨ ヤギプライムで全文を見る
              </el-button>
            </div>
          </div>
          <div v-else-if="summarizePreview.errorMessage"
            class="summarize-preview-status summarize-preview-status-error">
            <i class="el-icon-warning"></i> {{ summarizePreview.errorMessage }}
            <div class="summarize-preview-actions">
              <el-button size="small" @click="closeSummarizePreview">閉じる</el-button>
            </div>
          </div>
          <div v-else-if="summarizePreviewFirst">
            <div class="summarize-preview-head">
              <span class="summarize-preview-label">AIによる短縮案（案1：骨格キープ）</span>
              <span class="summarize-preview-meta">
                元: {{ (reason || '').length }}字 → {{ summarizePreviewFirst.length }}字
              </span>
            </div>
            <div class="summarize-preview-text" :class="{ 'is-truncated': !$globalVar.isYagiPrime }">
              {{ summarizePreviewDisplayText }}
            </div>
            <div v-if="!$globalVar.isYagiPrime" class="summarize-preview-gate">
              <p class="summarize-preview-gate-note">
                🔒 続きと、他の2パターン（言い換え／ミニマル）はヤギプライム会員限定です。
              </p>
              <div class="summarize-preview-actions">
                <el-button size="small" @click="closeSummarizePreview">閉じる</el-button>
                <el-button size="small" type="primary" @click="openYagiprimeFromPreview">
                  ✨ ヤギプライムで全文を見る
                </el-button>
              </div>
            </div>
            <div v-else class="summarize-preview-actions">
              <el-button size="small" @click="closeSummarizePreview">閉じる</el-button>
              <el-button size="small" type="primary" @click="applySummarizePreview">この案を採用</el-button>
              <el-button size="small" type="text" @click="openSummarizeModal">他の案も見る</el-button>
            </div>
          </div>
        </div>
      </div>

      <summarize-modal v-if="$globalVar.isYagiPrime && reason" modal-name="summarize-modal" :text="reason"
        :target-length="summarizeTargetLength" :variation-count="3" context="志望動機" @apply="applySummarize" />
    </div>

    <div v-if="formatId == 'rirekisho_job_change_old'">
      <p class="guidetxt">志望動機の見本（参考にして作成しましょう）</p>
      <img src="/static/img/rirekishoguide/guide06.png" alt="志望動機" class="guideimg">
    </div>

  </div>
</template>

<script>
import aiStreamingMixin from '../../mixins/ai-streaming-mixin'
import '../../assets/css/ai-streaming.css'
import SummarizeModal from '../../proofreading/phase2/summarize-modal.vue'
import { buildSummarizeFetcher } from '../../proofreading/phase2/summarize-api'

export default {
  name: 'ReasonCard',
  mixins: [aiStreamingMixin],
  components: {
    SummarizeModal
  },
  props: {
    formatId: {
      type: String,
      required: true
    },
    exampleSentences: {
      type: Object,
      required: true
    },
    textareaMinRows: {
      type: Number,
      required: true
    },
    previewErrors: {
      type: Object,
      required: true
    },
    formatData: {
      type: Object,
      required: true
    },
    currentCardId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      aiResultView: false,
      aiResultMyprResult: '',
      aiResultReasonResult: '',
      fullscreenLoading: false,
      loadingText: 'AIがあなたに最適なテキストを生成しています',
      isFromYagiprimeAgent: false,
      aiGeneratedExampleReason: '', // AI生成の例文（表示用）
      aiGeneratedExampleReasonFull: '', // AI生成の例文（全文保存用）
      isAiExampleGenerated: false, // 生成済みフラグ
      isGeneratingAiExample: false, // 生成中フラグ
      hopeIndustryOptions: ['', 'IT・通信', 'ソフトウェア・情報処理', 'インターネット関連・ゲーム・アプリ関連', '機械・産業用装置・電機・OA機器', '自動車・自動車部品・輸送用機器', 'コンピュータ・通信機器・精密機器', '電子部品・半導体', '食品・飲料・たばこ・飼料', '化学・医薬・化粧品', '鉄鋼・非鉄金属・金属製品', '石油・石炭・ゴム・プラスチック', 'ガラス・セラミック・セメント', 'パルプ・紙・紙加工・印刷・印刷関連', '日用品・文具・オフィス用品', '建材・エクステリア', 'インテリア・住宅関連', 'アパレル・服飾関連', 'スポーツ・玩具・ゲーム機器', 'その他メーカー・製造関連', '電気・ガス・石油・水道', '放送（テレビ・ラジオ含む）', '新聞・出版', '広告', 'その他（芸能・エンタテインメント関連等）', '運輸（鉄道・航空・海運・物流等）', '総合商社', '専門商社', '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター', '通信販売、専門店・その他小売り', '銀行（協同組織金融含む）', '証券', '保険', 'その他金融（クレジット等）', 'リース・レンタル', 'ディベロッパー', '建設・建築設計・ハウスメーカー', '設備関連', 'プラント・プラントエンジニアリング', '不動産取引・不動産賃貸・不動産管理', 'デザイン・芸術関連', 'コンサルティング・マーケティング・調査', 'その他専門・技術サービス', 'ホテル・旅館', '外食', 'その他フード', '理美容・エステ・フィットネスクラブ', '旅行・観光', '家事サービス・クリーニング', '冠婚葬祭', 'その他生活関連サービス', 'アミューズメント・レジャーサービス', '教育関連', '医療・保育・介護、福祉', '環境・リサイクル・廃棄物処理', '整備・修理', '人材サービス', 'その他事業サービス（警備、コールセンター等）', 'その他'],
      hopeCareerJobcategoryOptions: ['', '営業', '事務・秘書・受付', '経理', '総務人事', 'バイヤー', '法務', '知的財産部門', '企画', 'マーケティング', '宣伝・広報', '経営企画', '経営コンサルタント', '為替ディーラー・トレーダー', '証券アナリスト', '融資・資産運用(ファンドマネージャー等）', 'ファイナンシャルアドバイザー', 'アクチュアリー', 'システムエンジニア・プログラマ', 'Webエンジニア', 'ネットワークエンジニア', 'セキュリティエンジニア', 'インフラ・データエンジニア', 'AIエンジニア', '組み込みエンジニア', 'カスタマーエンジニア', '社内SE・情シス', '研究職（製造系）', '設計開発', '生産・製造', '物流・在庫管理', 'セールスエンジニア', '品質管理', '医療技術', 'MR（医薬情報担当者）', '研究開発（医薬系）', '薬剤師', '栄養士', '福祉士・介護士・ホームヘルパー', '講師・インストラクター', '専門コンサルタント', '建築・土木設計', '施工管理', 'Webプロデューサー・ディレクター', 'Webデザイナー', 'デザイナー', 'ゲームクリエイター', 'ゲームプログラマ', 'データサイエンティスト・アナリスト', '記者・ライター', '編集・制作', '販売・接客', '店長（店舗経営・運営）', 'スーパーバイザー', '農業', '林業', '漁業'],
      reasonLabels: {
        default: '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！',
        jobNew: '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
        jobNewSingle: '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
        reasonLabel20240717: '志望動機を入力してください。書き方に迷うときは、「AIで文章作成」ボタンから、AIが志望動機の下書きを自動作成できます。',
        reasonLabel20250126: 'あなたの入力した内容で志望動機を、AIで途中まで作成してみました。\n文章は編集することが可能です。',
        reasonLabelYagiprime: '最新のAIを使って、あなたらしい文章にしましょう！'
      },
      isSendMail: false,
      correctSentence: '',
      willInsertSentence: false,
      aiUsageCount: 0,
      aiMaxUsageCount: 1,
      // インライン短縮プレビュー（非会員にも 1 案だけ実 AI 結果を見せる訴求）
      summarizePreview: {
        visible: false,
        loading: false,
        errorMessage: '',
        rateLimited: false,
        summaries: [],
        abortController: null,
        applied: false
      },
      showFromNewAi: false,
      isAutoExecuteAfterPayment: false,
      isAiMyprDialogVisible: false,
      primeAdditionalInfo: null,
      isAgentAvailable: false,
      industrySuggestions: [],
      jobcategorySuggestions: [],
      currentIndustrySuggestions: [],
      currentJobcategorySuggestions: [],
      isExtractingCompanyInfo: false,
      isCompanyInfoExtracted: false,
      isGeneratingCareerSuggestions: false,
      isCareerSuggestionsGenerated: false,
      shouldRegenerateCareerSuggestions: false
    }
  },
  computed: {
    autosizeSettings () {
      let minRows
      if (window.innerWidth <= 768) {
        // rirekisho_job_change の場合は SP 時に最低6行、その他の場合は7行
        minRows = this.formatId === 'rirekisho_job_change' ? 7 : this.textareaMinRows
      } else {
        minRows = this.formatId === 'rirekisho_job_change' ? this.textareaMinRows + 1 : this.textareaMinRows
      }
      return { minRows, maxRows: 15 }
    },
    reason: {
      get () {
        return this.formatData.reason
      },
      set (value) {
        this.$emit('update:reason', value)
      }
    },
    getLicences: function () {
      let licensesStr = ''
      for (const key in this.formatData.licenseHistories) {
        licensesStr += this.formatData.licenseHistories[key].description + ','
      }
      return licensesStr
    },
    reasonLabel () {
      if (this.formatId === 'rirekisho_job_new') {
        return this.reasonLabels.jobNew
      } else if (this.formatId === 'rirekisho_job_new_single') {
        return this.reasonLabels.jobNewSingle
      }
      return this.reasonLabels.default
    },
    reasonLabel20240717 () {
      return this.reasonLabels.reasonLabel20240717
    },
    reasonLabel20250126 () {
      return this.reasonLabels.reasonLabel20250126
    },
    reasonLabelYagiprime () {
      return this.reasonLabels.reasonLabelYagiprime
    },
    summarizeTargetLength () {
      // 履歴書の志望動機としての標準的な分量（200〜300字）に収まるように短縮を狙う。
      // LLM プロンプトには「target ±10% / 3 案で長さに差をつける」と指示されており、
      // target=300 の場合の実出力は概ね 200〜330 字に分布する。
      // 元が短い場合（≤ 350 字）は「短くする必要が薄い」ので、緩めに 85% 目標。
      const current = (this.reason || '').length
      if (current <= 350) return Math.max(30, Math.floor(current * 0.85))
      return 300
    },
    summarizePreviewFirst () {
      return this.summarizePreview.summaries[0] || null
    },
    summarizePreviewDisplayText () {
      const first = this.summarizePreviewFirst
      if (!first || !first.text) return ''
      if (this.$globalVar.isYagiPrime) return first.text
      // 非会員: 頭から約 45% で truncate して「…」で続きを隠す
      const cutAt = Math.max(60, Math.floor(first.text.length * 0.45))
      return first.text.substring(0, cutAt) + '…'
    }
  },
  watch: {
    currentCardId: {
      handler (newVal) {
        // 志望動機ステップに来た時にAI候補を取得
        if (newVal === 'reason') {
          this.$nextTick(() => {
            // 再生成が必要な場合、または未生成の場合にAPI呼び出し
            if (this.shouldRegenerateCareerSuggestions || !this.isCareerSuggestionsGenerated) {
              this.shouldRegenerateCareerSuggestions = false
              this.isCareerSuggestionsGenerated = false
              this.fetchCareerSuggestions()
            }
          })
        }
      },
      immediate: true
    },
    // 学歴・職歴・資格のOKボタン押下時にイベントで再生成フラグを立てる
    // ※実際のAPI呼び出しは志望動機ステップに入った時に行う
    'formatData.lastestEdu' () {
      if (this.formatData.lastestEdu) {
        this.markCareerSuggestionsForRegeneration()
      }
    },
    'formatData.lastestJob' () {
      if (this.formatData.lastestJob) {
        this.markCareerSuggestionsForRegeneration()
      }
    },
    // AIダイアログ入力値が変わったら次回ステップ遷移時に候補を再生成
    'formatData.currentIndustrycategory' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.currentJobcategory' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.hopeIndustrycategory' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.hopeJobcategory' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.ai_strength' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.ai_company_name' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.ai_company_values' () {
      this.markCareerSuggestionsForRegeneration()
    },
    'formatData.ai_company_url' () {
      this.isCompanyInfoExtracted = false
      this.markCareerSuggestionsForRegeneration()
    }
  },
  beforeMount () {
    this.$eventHub.$on('open-login-dialog', this.openLoginDialog)
    this.$eventHub.$on('payment_yagiprime_result', this.handlePaymentResult)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
    this.$eventHub.$on('open-ai-reason-dialog', this.handleOpenAiReasonDialog)
    // 学歴・職歴・資格のOKボタン押下時に再生成フラグを立てる
    this.$eventHub.$on('deactivate-history-item', this.onHistoryItemDeactivated)
  },
  mounted () {
    // Vue 2 では未定義キーへの代入が非リアクティブになるため、
    // 新規 current 系フィールドを $set で初期化して PersonalRequestFields との同期を保証する
    if (!('currentIndustrycategory' in this.formatData)) {
      this.$set(this.formatData, 'currentIndustrycategory', '')
    }
    if (!('currentJobcategory' in this.formatData)) {
      this.$set(this.formatData, 'currentJobcategory', '')
    }

    // LocalStorageから保存済みのAI例文を取得
    this.loadAIExampleFromLocalStorage()

    // Firebase認証の初期化を待ってからAI例文を生成
    // ※候補チップ（fetchCareerSuggestions）は志望動機ステップに来た時のみ呼び出し
    const executeAiTasks = () => {
      this.generateAIExampleReason()
    }

    if (this.$firebase && this.$firebase.isAuthenticated) {
      // 既にログイン済みの場合は即座に実行
      this.$nextTick(() => {
        executeAiTasks()
      })
    } else {
      // 未ログインの場合は少し遅延させて実行（認証状態の確定を待つ）
      // setTimeout(() => {
      //   executeAiTasks()
      // }, 1500)
    }
  },
  destroyed () {
    this.$eventHub.$off('open-login-dialog', this.openLoginDialog)
    this.$eventHub.$off('payment_yagiprime_result', this.handlePaymentResult)
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
    this.$eventHub.$off('open-ai-reason-dialog', this.handleOpenAiReasonDialog)
    this.$eventHub.$off('deactivate-history-item', this.onHistoryItemDeactivated)
  },
  methods: {
    reasonClear () {
      this.formatData.reason = ''
      this.$message({
        message: '削除完了しました。',
        type: 'success'
      })
    },
    updateReason (text) {
      this.formatData.reason = text
    },
    openSummarizeModal () {
      if (!this.reason || this.reason.length < 50) {
        this.$message({
          message: '短縮提案を利用するには、もう少し文章を書いてください。',
          type: 'info'
        })
        return
      }
      this.$modal.show('summarize-modal')
    },
    applySummarize (newText) {
      if (typeof newText !== 'string' || !newText.trim()) return
      this.reason = newText
      this.$message({
        message: '短縮した文章を反映しました。必要に応じて編集してください。',
        type: 'success'
      })
    },
    showYagiprimeForSummarize () {
      // 非会員にも実 AI で 1 案だけ短縮結果を取得 → 続きを伏せて訴求
      this.loadSummarizePreview()
    },
    loadSummarizePreview () {
      this.summarizePreview.applied = false
      // 既に取得済みなら再表示のみ
      if (this.summarizePreview.summaries.length > 0) {
        this.summarizePreview.visible = true
        return
      }
      if (!this.reason || this.reason.length < 50) {
        this.summarizePreview.errorMessage = '文章が短いため、短縮提案の対象外です。'
        this.summarizePreview.visible = true
        return
      }
      const fetcher = buildSummarizeFetcher(this)
      if (!fetcher) {
        this.summarizePreview.errorMessage = '短縮機能が利用できません。時間をおいて再度お試しください。'
        this.summarizePreview.visible = true
        return
      }
      this.summarizePreview.visible = true
      this.summarizePreview.loading = true
      this.summarizePreview.errorMessage = ''
      this.summarizePreview.rateLimited = false
      const controller = (typeof AbortController !== 'undefined') ? new AbortController() : null
      this.summarizePreview.abortController = controller
      fetcher({
        text: this.reason,
        targetLength: this.summarizeTargetLength,
        variationCount: 3,
        context: '志望動機',
        signal: controller ? controller.signal : null
      }).then((summaries) => {
        this.summarizePreview.loading = false
        this.summarizePreview.abortController = null
        this.summarizePreview.summaries = Array.isArray(summaries) ? summaries : []
        if (this.summarizePreview.summaries.length === 0) {
          this.summarizePreview.errorMessage = '短縮案を生成できませんでした。文章を少し編集してから再度お試しください。'
        }
      }).catch((err) => {
        this.summarizePreview.loading = false
        this.summarizePreview.abortController = null
        if (this.$axios && this.$axios.isCancel && this.$axios.isCancel(err)) {
          return
        }
        const status = err && err.response && err.response.status
        if (status === 401 || err.code === 'UNAUTHENTICATED') {
          this.summarizePreview.errorMessage = 'ログインが必要です。'
        } else if (status === 429) {
          this.summarizePreview.rateLimited = true
        } else if (status === 502) {
          this.summarizePreview.errorMessage = 'AIサービスが一時的に利用できません。しばらくしてから再度お試しください。'
        } else {
          this.summarizePreview.errorMessage = '短縮案の取得に失敗しました。'
        }
      })
    },
    closeSummarizePreview () {
      if (this.summarizePreview.abortController) {
        this.summarizePreview.abortController.abort()
        this.summarizePreview.abortController = null
      }
      // 候補を見たのに採用せず閉じた = 明示破棄（採用済みなら二重記録しない）
      if (!this.summarizePreview.applied && this.summarizePreview.summaries.length > 0) {
        this.reportProofreadEvent('dismiss')
      }
      this.summarizePreview.visible = false
    },
    openYagiprimeFromPreview () {
      // 既存の文字数オーバー訴求と同じ機能タイプを使う（ShibouDoukishoEdit と同パターン）。
      // routeId Cookie を立てておかないと決済完了後の callback で currentFeature が null になる。
      const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID') || ''
      this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#reason_long', null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#reason_long', null, null, 'localhost')
      this.$eventHub.$emit('show-yagiprime-payment-dialog', 'reason_long')
    },
    applySummarizePreview () {
      const first = this.summarizePreviewFirst
      if (!first || !first.text) return
      this.reason = first.text
      this.summarizePreview.applied = true
      // インラインプレビュー（案1）の採用も記録する（モーダルを通らない主経路）
      this.reportProofreadEvent('accept', { candidateIndex: 0 })
      this.summarizePreview.visible = false
      this.$message({
        message: '短縮した文章を反映しました。',
        type: 'success'
      })
    },
    // 採用 / 破棄イベントを varuna に記録（fire-and-forget・summarize-modal と同方式）
    reportProofreadEvent (action, extra) {
      const uid = (this.$firebase && this.$firebase.user && this.$firebase.user.uid) || null
      const endpoint = this.$varuna && this.$varuna.endPoints && this.$varuna.endPoints.proofreadEvent
      if (!uid || !endpoint) return
      const payload = { uuid: uid, feature: 'summarize', action }
      if (extra && typeof extra.candidateIndex === 'number') {
        payload.candidate_index = extra.candidateIndex
      }
      try {
        this.$axios.post(endpoint, payload, { timeout: 5000 }).catch(() => {})
      } catch (e) {
        /* noop */
      }
    },
    getAIMyprAuto () {
      const app = this
      app.fullscreenLoading = true
      if (app.formatData.reason && app.formatData.reason.trim() !== '') {
        app.fullscreenLoading = false
      }
      if (app.fullscreenLoading) {
        if (app.$cookies.get('AutoReason')) {
          const autoReason = app.$cookies.get('AutoReason')
          let reason = ''
          if (!app.$firebase.isAuthenticated || !app.$globalVar.isYagiPrime) {
            reason = autoReason.substring(0, 100) + '...'
          } else {
            reason = autoReason
          }
          if (!app.formatData.reason || app.formatData.reason.trim() === '') {
            app.formatData.reason = reason
            app.$cookies.set('AutoReason', reason)
            app.$message({
              message: '自動で志望動機を取得しました',
              type: 'success'
            })
          }
          app.fullscreenLoading = false
          return
        }

        this.$axios
          .post(this.$varuna.endPoints.AIAutoReason, app.formatData, { timeout: 60000 })
          .then((response) => {
            if (response.data.success) {
              const responseMessage = response.data.message
              let reason = ''
              if (!app.$firebase.isAuthenticated || !app.$globalVar.isYagiPrime) {
                reason = responseMessage.substring(0, 100) + '...'
              } else {
                reason = responseMessage
              }
              if (!app.formatData.reason || app.formatData.reason.trim() === '') {
                app.formatData.reason = reason
                app.$cookies.set('AutoReason', reason)
                app.$message({
                  message: '自動で志望動機を取得しました',
                  type: 'success'
                })
              }
            }
          })
          .finally(() => {
            app.fullscreenLoading = false
          })
      }
    },
    extractCompanyInfo () {
      const url = this.formatData.ai_company_url
      if (!url) {
        this.$message({ message: 'URLを入力してください', type: 'warning' })
        return
      }
      this.isExtractingCompanyInfo = true
      this.$axios.post(this.$varuna.endPoints.aiExtractCompanyInfo, { url })
        .then((response) => {
          if (response.data.success && response.data.data) {
            const data = response.data.data
            if (data.company_name) {
              this.formatData.ai_company_name = data.company_name
            }
            if (data.industry) {
              this.formatData.hopeIndustrycategory = data.industry
            }
            if (data.job) {
              this.formatData.hopeJobcategory = data.job
            }
            if (data.values) {
              this.formatData.ai_company_values = data.values
            }
            this.isCompanyInfoExtracted = true
            this.$message({ message: '企業情報を取得しました', type: 'success' })
          } else {
            this.$message({ message: '企業情報の取得に失敗しました', type: 'error' })
          }
        })
        .catch(() => {
          this.$message({ message: '企業情報の取得に失敗しました', type: 'error' })
        })
        .finally(() => {
          this.isExtractingCompanyInfo = false
        })
    },
    handleAIMypr () {
      // 非プライムでも aiUsageCount < 1 なら無料で1回実行（ポップアップは閉じない）
      if (!this.$globalVar.isYagiPrime && this.aiUsageCount < 1) {
        this.isAutoExecuteAfterPayment = true
        this.getAIMypr()
        return
      }

      // 課金フロー前にポップアップを一時的に閉じる
      if (this.isAiMyprDialogVisible) {
        this.$modal.hide('ai-mypr-dialog')
        this.isAiMyprDialogVisible = false
      }

      this.$yagiprimePaymentService.useFeature(this, 'self-introduction-shokumu', {
        onSuccess: () => {
          // 課金成功後、志望動機文章の作成処理を自動実行
          this.executeAIMyprAfterPayment()
        },
        onCancel: () => {
          // 課金失敗・キャンセル時は志望動機文章作成ポップアップを再表示
          setTimeout(() => {
            this.$modal.show('ai-mypr-dialog')
            this.isAiMyprDialogVisible = true
          }, 300)
        }
      })
    },
    executeAIMyprAfterPayment () {
      // 課金完了後、志望動機文章の作成処理を自動実行（ストリーミングなのでfullscreenLoadingは不要）
      this.isAutoExecuteAfterPayment = true
      this.getAIMypr()
    },
    getAIMypr () {
      const app = this
      const formData = new FormData()

      if (app.$firebase && app.$firebase.isAuthenticated) {
        formData.append('uuid', app.$firebase.user.uid)
        formData.append('education', app.formatData.lastestEdu || '')
        formData.append('job', app.formatData.lastestJob || '')
        formData.append('licenses', (app.formatData.licenseHistories && app.formatData.licenseHistories.map(l => l.description).join(',')) || '')
        formData.append('strength', app.formatData.ai_strength || '')
        formData.append('company_name', app.formatData.ai_company_name || '')
        formData.append('company_industry', app.formatData.hopeIndustrycategory || '')
        formData.append('company_job', app.formatData.hopeJobcategory || '')
        formData.append('company_url', app.formatData.ai_company_url || '')
        formData.append('company_values', app.formatData.ai_company_values || '')
        formData.append('current_industry', app.formatData.currentIndustrycategory || '')
        formData.append('current_job', app.formatData.currentJobcategory || '')
        formData.append('reason', app.formatData.reason || '')

        // ストリーミング開始と同時にポップアップを表示
        this.$modal.show('ai-mypr-dialog')
        this.isAiMyprDialogVisible = true

        this.startAIStream(this.$varuna.endPoints.aiIntroduceReason, formData, {
          resultField: 'aiResultMyprResult',
          viewField: 'aiResultView',
          onDone: () => {
            app.isAutoExecuteAfterPayment = false
          },
          onError: (error) => {
            const message = error.message || '失敗しました'
            if (message === 'AIの使用回数が上限に達しました。') {
              app.$eventHub.$emit('show-yagiprime-payment-dialog', 'self_introduction')
            }
            // エラー時もフラグをリセット
            app.isAutoExecuteAfterPayment = false
          }
        })
      }
    },
    getAIMyprContinue () {
      const app = this
      const formData = new FormData()

      if (app.$firebase && app.$firebase.isAuthenticated) {
        formData.append('uuid', app.$firebase.user.uid)
      }
      // プロパティをdataにまとめる
      formData.append('data', '作成文章:短めの志望動機\n' +
        '学歴:' + (app.formatData.lastestEdu || '') + '\n' +
        '職歴:' + (app.formatData.lastestJob || '') + '\n' +
        '資格:' + ((app.formatData.licenseHistories && app.formatData.licenseHistories.map(l => l.description).join(',')) || '') + '\n' +
        '得意なこと:' + (app.formatData.ai_strength || '') + '\n' +
        '希望企業名:' + (app.formatData.ai_company_name || '') + '\n' +
        '希望業界:' + (app.formatData.hopeIndustrycategory || '') + '\n' +
        '希望職種:' + (app.formatData.hopeJobcategory || '') + '\n' +
        '現在の業界:' + (app.formatData.currentIndustrycategory || '') + '\n' +
        '現在の職種:' + (app.formatData.currentJobcategory || '') + '\n' +
        '志望動機:' + (app.formatData.reason || '') +
        '文章:' + (app.aiResultMyprResult.replace(/<br>/ig, '\n')))

      this.startAIStream(this.$varuna.endPoints.aiSentenseContinue, formData, {
        resultField: 'aiResultMyprResult',
        viewField: 'aiResultView',
        onError: (error) => {
          const message = error.message || '失敗しました'
          if (message === 'AIの使用回数が上限に達しました。') {
            app.$eventHub.$emit('show-yagiprime-payment-dialog', 'self_introduction')
          }
        }
      })
    },
    goYagiprimeRegister () {
      // this.$cookies.config(60 * 60 * 24, '')
      // const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      // this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'yagish.jp')
      // this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'localhost')
      // location.href = '/yagiprime_register'

      this.$yagiprimePaymentService.useFeature(this, 'self_introduction', {
        onSuccess: () => {
          this.getAIMyprContinue()
        },
        onCancel: () => {
          this.$modal.hide('ai-mypr-dialog')
          this.aiResultView = false
        }
      })
    },
    getAiUsageCount () {
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('category_type', 'reason')
      this.$axios.post(this.$varuna.endPoints.getAiUsageCount, formData).then((response) => {
        if (response.data.success) {
          this.aiUsageCount = response.data.usage_count || 0
          // ヤギプライム会員の場合は最大10回、それ以外は1回
          this.aiMaxUsageCount = this.$globalVar.isYagiPrime ? 10 : 1
        }
      })
    },
    showAiMyprDialog () {
      if (this.$firebase.isAuthenticated) {
        this.getAiUsageCount()
      } else {
        this.aiUsageCount = 1
      }

      this.isFromYagiprimeAgent = false
      if (!this.$firebase.isAuthenticated) {
        this.$eventHub.$emit('open-login-dialog')
        return
      }
      if (!this.$globalVar.isYagiPrime) {
        const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
        this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#self_introduction', null, null, 'yagish.jp')
        this.$eventHub.$emit('show-yagiprime-payment-dialog', 'self_introduction')
        return
      }
      this.$modal.show('ai-mypr-dialog')
      this.isAiMyprDialogVisible = true
    },
    showModalFromNewAi () {
      this.showFromNewAi = true
      if (this.$firebase.isAuthenticated) {
        this.getAiUsageCount()
        this.$modal.show('ai-mypr-dialog')
      } else {
        this.aiUsageCount = 1
        this.$modal.show('ai-mypr-dialog')
      }
      this.isAiMyprDialogVisible = true
    },
    toggleAIMyprDialog () {
      this.aiResultView = false
    },
    closeAiMyprDialog () {
      this.$modal.hide('ai-mypr-dialog')
      this.isAiMyprDialogVisible = false
    },
    authStateChanged () {
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      const app = this

      app.$axios
        .post(app.$varuna.endPoints.subscriptionsMypage, formData, { timeout: 60000 })
        .then(function (response) {
          console.error('response.data')
          console.error(response.data)
          app.primeAdditionalInfo = response.data
          // response.data.agentsがあれば、true、なければfalse
          app.isAgentAvailable = !!response.data.agents

          // 会員状態が確定したので、AI例文の表示を更新
          app.updateAIExampleDisplay()

          // Firebase認証が完了したタイミングでAI例文を生成
          // ※候補チップは志望動機ステップに来た時のみ呼び出し（currentCardId watcherで実行）
          app.generateAIExampleReason()
          // 志望動機ステップにいる場合のみ候補を取得
          if (app.currentCardId === 'reason') {
            app.fetchCareerSuggestions()
          }
        })

      this.$axios
        .post(this.$varuna.endPoints.isSendCorrectionMail, formData, { timeout: 60000 })
        .then((response) => {
          app.isSendMail = response.data.success
          app.correctSentence = response.data.sentence
        })
    },
    insertSentence () {
      // もし、ヤギプライムでない場合は、課金ポップアップを表示
      this.willInsertSentence = true
      if (!this.$globalVar.isYagiPrime) {
        // LocalStorageを使用
        localStorage.setItem('correctSentence', this.correctSentence)

        this.$eventHub.$emit('open-yagiprime-payment-dialog')
        return
      }
      this.formatData.reason = this.correctSentence
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.insertedSentence, formData, { timeout: 60000 })

      this.$message({
        message: '追加しました',
        type: 'success'
      })
    },
    fetchCareerSuggestions () {
      // 未ログイン時はAPIを呼ばない
      if (!this.$firebase || !this.$firebase.isAuthenticated) {
        return
      }

      // 既に候補生成済み、または生成中であれば何もしない
      if (this.isCareerSuggestionsGenerated || this.isGeneratingCareerSuggestions) {
        return
      }

      // 最低限の情報がない場合は呼び出さない
      // 空の項目のみの配列は「情報なし」として扱う
      const hasValidEducation = this.formatData.educationalHistories &&
        this.formatData.educationalHistories.some(item => item && item.description && item.description.trim())
      const hasValidJob = this.formatData.jobHistories &&
        this.formatData.jobHistories.some(item => item && item.description && item.description.trim())
      const hasValidLicense = this.formatData.licenseHistories &&
        this.formatData.licenseHistories.some(item => item && item.description && item.description.trim())

      const hasMinimumInfo =
        hasValidEducation ||
        hasValidJob ||
        hasValidLicense ||
        (this.formatData.lastestEdu && this.formatData.lastestEdu.trim()) ||
        (this.formatData.lastestJob && this.formatData.lastestJob.trim()) ||
        (this.formatData.ai_strength && this.formatData.ai_strength.trim())

      if (!hasMinimumInfo) {
        this.isCareerSuggestionsGenerated = true
        return
      }

      this.isGeneratingCareerSuggestions = true

      const payload = {
        uuid: (this.$firebase && this.$firebase.isAuthenticated) ? this.$firebase.user.uid : null,
        educationalHistories: this.formatData.educationalHistories || [],
        jobHistories: this.formatData.jobHistories || [],
        licenseHistories: this.formatData.licenseHistories || [],
        lastestEdu: this.formatData.lastestEdu || '',
        lastestJob: this.formatData.lastestJob || '',
        strength: this.formatData.ai_strength || '',
        reason: this.formatData.reason || '',
        current_industry: this.formatData.currentIndustrycategory || '',
        current_job: this.formatData.currentJobcategory || '',
        hope_industry: this.formatData.hopeIndustrycategory || '',
        hope_job: this.formatData.hopeJobcategory || '',
        ai_company_name: this.formatData.ai_company_name || '',
        ai_company_url: this.formatData.ai_company_url || '',
        ai_company_values: this.formatData.ai_company_values || '',
        licensesText: this.getLicences || '',
        industry_options: (this.hopeIndustryOptions || []).filter(item => item),
        jobcategory_options: (this.hopeCareerJobcategoryOptions || []).filter(item => item)
      }

      this.$axios
        .post(this.$varuna.endPoints.aiCareerRecommendations, payload, { timeout: 60000 })
        .then((response) => {
          if (response.data && response.data.success) {
            this.industrySuggestions = response.data.industries || []
            this.jobcategorySuggestions = response.data.jobCategories || []
            this.currentIndustrySuggestions = response.data.currentIndustries || []
            this.currentJobcategorySuggestions = response.data.currentJobCategories || []
          }
        })
        .catch(() => {
          // 候補生成エラー時もトーストは表示しない
        })
        .finally(() => {
          this.isGeneratingCareerSuggestions = false
          this.isCareerSuggestionsGenerated = true
        })
    },
    markCareerSuggestionsForRegeneration () {
      // 学歴・職歴・資格が変更されたら再生成フラグを立てる
      // 実際のAPI呼び出しは志望動機ステップに入った時に行う
      this.shouldRegenerateCareerSuggestions = true
    },
    onHistoryItemDeactivated () {
      // 学歴・職歴・資格のOKボタンが押されたら再生成フラグを立てる
      this.markCareerSuggestionsForRegeneration()
    },

    selectIndustrySuggestion (item) {
      if (!item) return
      this.$set(this.formatData, 'hopeIndustrycategory', item)
      this.$set(this.formatData, 'hopeIndustry', item)
    },
    selectJobcategorySuggestion (item) {
      if (!item) return
      this.$set(this.formatData, 'hopeJobcategory', item)
    },
    selectCurrentIndustrySuggestion (item) {
      if (!item) return
      this.$set(this.formatData, 'currentIndustrycategory', item)
    },
    selectCurrentJobcategorySuggestion (item) {
      if (!item) return
      this.$set(this.formatData, 'currentJobcategory', item)
    },

    handleOpenAiReasonDialog () {
      // AiReasonBnr.vueからのイベントを受け取り、「続きを作成する」ボタンと同じポップアップを表示
      this.showModalFromNewAi()
    },
    loadAIExampleFromLocalStorage () {
      try {
        const storageKey = 'ai_generated_reason_example'
        const savedData = localStorage.getItem(storageKey)

        if (savedData) {
          const parsedData = JSON.parse(savedData)
          const now = Date.now()
          const expirationTime = 7 * 24 * 60 * 60 * 1000 // 7日間

          // 保存から7日以内であれば使用
          if (parsedData.timestamp && (now - parsedData.timestamp) < expirationTime) {
            // 全文を保存
            this.aiGeneratedExampleReasonFull = parsedData.text
            // 表示用テキストを更新
            this.updateAIExampleDisplay()
            this.isAiExampleGenerated = true
            console.log('AI例文をLocalStorageから読み込みました')
          } else {
            // 期限切れの場合は削除
            localStorage.removeItem(storageKey)
          }
        }
      } catch (error) {
        console.error('LocalStorageからのAI例文読み込みエラー:', error)
      }
    },
    updateAIExampleDisplay () {
      // 会員状態に応じて表示テキストを調整
      if (this.aiGeneratedExampleReasonFull) {
        if (this.$firebase && this.$firebase.isAuthenticated && this.$globalVar.isYagiPrime) {
          // YagiPrime会員の場合は全文表示
          this.aiGeneratedExampleReason = this.aiGeneratedExampleReasonFull
        } else {
          // 非ログイン/非YagiPrimeの場合は100文字まで
          this.aiGeneratedExampleReason = this.aiGeneratedExampleReasonFull.substring(0, 100) + '...'
        }
      }
    },
    saveAIExampleToLocalStorage (text) {
      try {
        const storageKey = 'ai_generated_reason_example'
        const data = {
          text,
          timestamp: Date.now()
        }
        localStorage.setItem(storageKey, JSON.stringify(data))
        console.log('AI例文をLocalStorageに保存しました')
      } catch (error) {
        console.error('LocalStorageへのAI例文保存エラー:', error)
      }
    },
    async generateAIExampleReason () {
      // 既に生成済みまたは生成中の場合はスキップ
      if (this.isAiExampleGenerated || this.isGeneratingAiExample) {
        return
      }

      // 最低限の情報があるかチェック（学歴、職歴、得意なことのいずれかが必要）
      const hasMinimumInfo =
        (this.formatData.educationalHistories && this.formatData.educationalHistories.length > 0) ||
        (this.formatData.jobHistories && this.formatData.jobHistories.length > 0) ||
        this.formatData.lastestEdu ||
        this.formatData.lastestJob ||
        this.formatData.ai_strength ||
        (this.formatData.licenseHistories && this.formatData.licenseHistories.length > 0)

      if (!hasMinimumInfo) {
        // 情報が不足している場合はAI例文生成をスキップ
        this.isGeneratingAiExample = false
        this.isAiExampleGenerated = true // 再試行を防ぐ
        return
      }

      this.isGeneratingAiExample = true
      const formData = new FormData()

      // 認証済みの場合はUUIDを追加
      if (this.$firebase && this.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }

      // 既存のgetAIMyprと同じパラメータ設定
      formData.append('education', this.formatData.lastestEdu || '')
      formData.append('job', this.formatData.lastestJob || '')
      formData.append('licenses', (this.formatData.licenseHistories && this.formatData.licenseHistories.map(l => l.description).join(',')) || '')
      formData.append('strength', this.formatData.ai_strength || '')
      formData.append('company_name', this.formatData.ai_company_name || '')
      formData.append('company_industry', this.formatData.hopeIndustrycategory || '')
      formData.append('company_job', this.formatData.hopeJobcategory || '')
      formData.append('current_industry', this.formatData.currentIndustrycategory || '')
      formData.append('current_job', this.formatData.currentJobcategory || '')
      formData.append('reason', this.formatData.reason || '')

      try {
        const response = await this.$axios.post(
          this.$varuna.endPoints.aiIntroduceReason,
          formData,
          { timeout: 60000 }
        )

        if (response.data.success) {
          const generatedText = response.data.message

          // エラーメッセージや不適切な応答をチェック
          const isErrorMessage = generatedText.includes('申し訳ありません') ||
            generatedText.includes('提供されていない') ||
            generatedText.includes('ご提供いただけますでしょうか') ||
            generatedText.length < 50 // 短すぎる応答もスキップ

          if (isErrorMessage) {
            // エラーメッセージの場合はAI例文を表示しない
            console.log('AI例文生成: 情報不足のため生成をスキップ')
            this.isAiExampleGenerated = true
            return
          }

          // 全文を保存
          this.aiGeneratedExampleReasonFull = generatedText
          // 表示用テキストを更新
          this.updateAIExampleDisplay()
          this.isAiExampleGenerated = true

          // LocalStorageに保存（全文を保存）
          this.saveAIExampleToLocalStorage(generatedText)
        }
      } catch (error) {
        console.error('AI例文生成エラー:', error)
        // エラー時は例文なしで続行（ユーザーには通知しない）
      } finally {
        this.isGeneratingAiExample = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/prime-ai-reason.scss';

.summarize-link-row {
  margin-top: 6px;
}

.summarize-link {
  color: #3b82f6;
  font-size: 13px;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #2563eb;
  }

  &.summarize-link-gate {
    color: #888;
  }
}

.summarize-preview-inline {
  margin-top: 10px;
  padding: 12px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: #fafafa;
}

.summarize-preview-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #666;
  padding: 6px 0;

  &.summarize-preview-status-error {
    color: #c0392b;
    flex-direction: column;
    align-items: flex-start;
  }
}

.summarize-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 8px;
}

.summarize-preview-label {
  font-size: 12px;
  font-weight: bold;
  color: #166534;
  background: #dcfce7;
  padding: 3px 8px;
  border-radius: 4px;
  letter-spacing: 0.3px;
}

.summarize-preview-meta {
  font-size: 11px;
  color: #666;
}

.summarize-preview-text {
  white-space: pre-wrap;
  font-size: 13px;
  line-height: 1.7;
  color: #222;
  padding: 8px 0;

  &.is-truncated {
    position: relative;
    color: #444;
  }
}

.summarize-preview-gate {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #d0d0d0;
}

.summarize-preview-gate-note {
  font-size: 12px;
  color: #555;
  margin: 0 0 10px;
  line-height: 1.6;
}

.summarize-preview-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;

  >* {
    flex: 0 1 auto;
  }
}

.summarize-preview-rate-limit {
  padding: 4px 0;
}

.summarize-preview-rate-limit-title {
  font-size: 13px;
  font-weight: bold;
  color: #d97706;
  margin: 0 0 8px;
}

.overflow-scroll-y {
  overflow-y: auto;
}

.card-header {
  padding: 1rem;

  h2 {
    margin: 0;
    font-size: 1.2rem;
  }
}

.card-content {
  padding: 1rem;
}

.attention {
  color: #f56c6c;
  font-size: 0.9rem;
}

.button-block {

  .primary-button {
    position: relative;
    background: #FF8C00;
    color: rgb(255, 255, 255);
    border: none;
    margin-right: 10px;
    padding: 0 20px;
    border-radius: 4px;

    &::after {
      position: absolute;
      content: "✨";
      font-size: 20px;
      top: -5px;
      right: -7px;
    }

  }

  @media screen and (max-width: 768px) {
    margin-right: 0;
    padding: 0;
    justify-content: center;
  }
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 10px;

  // SP対応
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }

  button {
    width: 200px;
    padding: 10px 0;
    border-radius: 5px;
    font-weight: bold;
    display: block;

    &.primary-button {
      background: #8fbd67ff;
      color: rgb(255, 255, 255);
      border: none;
      margin-right: 10px;

      @media screen and (max-width: 768px) {
        margin-bottom: 10px;
        margin-right: 0;
      }
    }

    &.secondary-button {
      background: rgb(255, 255, 255);
      border: 1px solid #8fbd67ff;
      color: #8fbd67ff;
    }
  }
}

.text-right {
  text-align: right;
}

//tips
.tips {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;

  &__accordion {
    background: #eef5e8;
    border-radius: 6px;
    padding: 5px 10px;
    margin-bottom: 10px;
    font-size: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }

    summary {
      position: relative;
      color: #004D40;
      font-weight: bold;
      list-style-type: none;
      -webkit-appearance: none;

      &::after {
        position: absolute;
        content: "";
        background-image: url(/static/img/closebtn.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
        width: 15px;
        height: 15px;
        right: -15px;
      }
    }

    summary::-webkit-details-marker {
      display: none;
    }

    &:not([open]) {
      summary {
        &::after {
          background-image: url(/static/img/openbtn.svg);
          top: -5px;
        }
      }
    }
  }
}

.guidetxt {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
}

.guideimg {
  display: block;
  width: 70%;
  margin: 0 auto 20px;

  @include max-width(sm) {
    width: 100%;
  }

}

.id-old-txt {
  font-weight: bold;
  text-align: center;
}

// proofread-tips-modal
.proofread-tips-content {
  padding: 0;
  margin-top: -30px;
}

.proofread-tips-main-title {
  font-size: 1.05rem;
  font-weight: bold;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}

.proofread-section-heading {
  font-size: 0.95rem;
  font-weight: bold;
  border-left: 3px solid #333;
  padding-left: 8px;
  margin: 0 0 12px;

  &--mt {
    margin-top: 20px;
  }
}

.proofread-steps {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  padding: 4px 0;
}

.proofread-step {
  text-align: center;
  flex: 1;
}

.proofread-step-icon {
  width: 54px;
  height: 54px;
  border-radius: 12px;
  margin: 0 auto 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;

  &--neutral {
    background: #f0f0f0;
    color: #666;
  }

  &--alert {
    background: #fde8e8;
    color: #d9534f;
  }
}

.proofread-wavy-mark {
  font-size: 1.8rem;
  color: #d9534f;
}

.proofread-step-name {
  font-size: 0.78rem;
  font-weight: bold;
  margin-bottom: 4px;
  white-space: nowrap;
}

.proofread-step-desc {
  font-size: 0.7rem;
  color: #666;
  line-height: 1.4;
}

.sp-only {
  display: none;

  @media (max-width: 480px) {
    display: inline;
  }
}

.proofread-step-arrow {
  font-size: 1.4rem;
  color: #bbb;
  padding-top: 14px;
  flex-shrink: 0;
  margin: 0 4px;
}

.proofread-points-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 8px;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.proofread-point {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fff;

  &--beige {
    background: #f7f3ea;
    border-color: #e8d9c0;
  }

  &--salmon {
    background: #fdf2ee;
    border-color: #f0d4c8;
  }

  &--green {
    background: #f0f8f0;
    border-color: #c8e0c8;
  }
}

.proofread-point-icon {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  flex-shrink: 0;

  &--beige {
    background: #e8c99a;
    color: #5a3e1b;
  }

  &--salmon {
    background: #f0b8a0;
    color: #7a2c10;
  }

  &--green {
    background: #90c890;
    color: #1a4a1a;
  }

  &--neutral {
    background: #e8e8e8;
    color: #555;
  }
}

.proofread-point-body {
  min-width: 0;
}

.proofread-point-title {
  font-weight: bold;
  font-size: 0.75rem;
  color: #333;
  line-height: 1.3;
}

.proofread-point-sub {
  font-size: 0.68rem;
  color: #666;
  margin-top: 2px;
}

.proofread-prime-desc {
  font-size: 13px;
  color: #555;
  margin-bottom: 8px;
}

.proofread-prime-list {
  font-size: 13px;
  color: #555;
  margin-bottom: 16px;

  li {
    margin-bottom: 4px;
  }
}

.proofread-faq {
  border-top: 1px solid #eee;
}

.proofread-faq-item {
  border-bottom: 1px solid #eee;

  summary {
    cursor: pointer;
    padding: 12px 24px 12px 0;
    font-weight: bold;
    font-size: 0.85rem;
    position: relative;
    list-style: none;
    display: block;
    color: #333;

    &::-webkit-details-marker {
      display: none;
    }

    &::after {
      content: '›';
      position: absolute;
      right: 4px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 1.2rem;
      color: #aaa;
      transition: transform 0.2s;
    }
  }

  &[open]>summary::after {
    transform: translateY(-50%) rotate(90deg);
  }
}

.proofread-faq-answer {
  padding: 0 0 14px;
  font-size: 0.82rem;
  color: #555;
  line-height: 1.7;
}

// 「現在のあなたのいる業界/職種」サブ質問タイトル
.sub-question-title {
  margin-top: 12px;
  font-size: 0.95rem;
  color: #444;
}

// メインCTA「AIで文章作成をする」赤大ボタン
.ai-mypr-cta-btn {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 14px 0;
  font-size: 1rem;
  font-weight: bold;
  color: #fff;
  background-color: #e3165c;
  border-color: #e3165c;
  border-radius: 6px;

  &:hover,
  &:focus {
    background-color: #c9135a;
    border-color: #c9135a;
    color: #fff;
  }
}

.ai-mypr-cta-note {
  margin-top: 6px;
  text-align: center;
  color: #e3165c;
  font-size: 0.85rem;
  font-weight: bold;
}

.ai-mypr-self-title {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
}

// AI生成例文のスタイル
.ai-generated-example {

  .title {
    display: flex;
    align-items: center;
    gap: 8px;

    .ai-badge {
      display: inline-block;
      background-color: #0F9934;
      color: #ffffff;
      font-size: 10px;
      font-weight: bold;
      padding: 2px 6px;
      border-radius: 3px;
    }
  }
}
</style>

<style lang="scss">
.company-url-input .el-input-group__append {
  background-color: #e6393f;
  border-color: #e6393f;
  color: #fff;
  padding: 0 15px;

  &:hover {
    background-color: #c9353a;
  }

  .el-button {
    color: #fff;
  }
}
</style>
